import React, { useEffect } from "react";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { axiosGet } from "../utils/AxiosUtils";
import Autocomplete from "@mui/material/Autocomplete";
import RefreshIcon from "@mui/icons-material/Refresh";
import { formatLabel } from "../utils/SaitUtils";
import { Box, IconButton, InputAdornment } from "@mui/material";

export default function SaitCombo(props) {
	const defaultSize = "small";

	const [itemsCombo, setItemsCombo] = React.useState([]);
	const [loadingFind, setLoadingFind] = React.useState(false);

	useEffect(() => {
		setItemsForAutocomplete(props.items);
		// eslint-disable-next-line
	}, [JSON.stringify(props.items)]);

	/////// FIND A DB ///////
	useEffect(() => {
		if (props.findParameters && !props.disabled) {
			setLoadingFind(true);
		}
		// eslint-disable-next-line
	}, [JSON.stringify(props.findParameters), props.disabled]);

	useEffect(() => {
		if (loadingFind) {
			getItemsFindFunction();
		}
		// eslint-disable-next-line
	}, [loadingFind]);

	const getItemsFindFunction = async () => {
		const resp = await axiosGet(props.findParameters.findFunction, props.findParameters.findFilters, props.findParameters.orderBy);
		setItemsForAutocomplete(resp.rows);
		setLoadingFind(false);
	};
	////////////////////////////

	const setItemsForAutocomplete = (items) => {
		let autoCompleteArray = [];
		items?.forEach((item) => {
			let labelDescription = formatLabel(props.description, item);

			item.customOptionLabel = labelDescription;

			autoCompleteArray.push(item);
		});
		setItemsCombo(autoCompleteArray);
	};

	const handleOnChange = (newValue) => {
		props.onChange(newValue);
	};

	const getOptionLabel = (option) => {
		if (option.customOptionLabel) {
			return option.customOptionLabel;
		} else {
			const item = itemsCombo.find((row) => {
				return props.name.every((obj) => {
					return row[obj.comboName] === props.value[obj.storeName];
				});
			});
			return item ? item.customOptionLabel : "";
		}
	};

	const textFieldStyle = {
		"& .MuiOutlinedInput-root.Mui-disabled": {
			backgroundColor: "#f0f0f0",
			borderRadius: 1,
		},
		"& .MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input.Mui-disabled": {
			color: "#212121", // colore testo più scuro
			WebkitTextFillColor: "#212121", // forza colore su Chrome/Edge
		},
		"& .MuiInputLabel-root.Mui-disabled": {
			color: "#424242",
		},
	};

	return (
		<Autocomplete
			options={props.findParameters ? ["ReloadComboJsws", ...itemsCombo] : itemsCombo}
			sx={{
				...props.sx,
			}}
			disabled={(!props.findParameters && props.items === null && !props.filterOptions) || loadingFind || props.disabled || props.readOnly}
			value={props.value[props.name[0].storeName] || props.value[props.name[0].storeName] === 0 ? props.value : null}
			onChange={(event, newValue) => handleOnChange(newValue)}
			isOptionEqualToValue={(option, value) => {
				return props.name.every((combo) => option[combo.comboName] === value[combo.storeName]);
			}}
			getOptionLabel={getOptionLabel}
			filterOptions={props.filterOptions}
			onInputChange={props.onInputChange}
			renderInput={(params) =>
				((!props.findParameters && props.items === null) || loadingFind) && !props.disabled && !props.filterOptions ? (
					// Se sto caricando i record da DB metto un textfield con un CircularProgress
					<TextField
						{...params}
						label={props.label}
						size={props.size || defaultSize}
						sx={textFieldStyle}
						slotProps={{
							input: {
								startAdornment: (
									<InputAdornment position="start">
										<CircularProgress size={30} />
									</InputAdornment>
								),
							},
						}}
						disabled={props.disabled || props.readOnly}
					/>
				) : (
					<TextField
						{...params}
						required={props.required}
						label={props.label}
						sx={textFieldStyle}
						error={props.error}
						size={props.size || defaultSize}
						disabled={props.disabled || props.readOnly}
					/>
				)
			}
			renderOption={(renderProps, option, { selected }) => {
				// @ts-ignore
				let { key, limitTags, findParameters, ...restRenderProps } = renderProps;
				if (option === "ReloadComboJsws") {
					return (
						<Box
							key={"RELOAD"}
							component="li"
							{...restRenderProps}
							sx={{
								display: "flex",
								justifyContent: "center !important",
								padding: 0,
							}}
						>
							<IconButton
								size="small"
								onClick={() => {
									setLoadingFind(true);
								}}
							>
								<RefreshIcon />
							</IconButton>
						</Box>
					);
				} else {
					return (
						<li key={key} {...restRenderProps}>
							{/* Multiple non gestito in EditPanel */}
							{/* {props.multiple && <Checkbox icon={<CheckBoxOutlineBlankIcon fontSize="small" />} checkedIcon={<CheckBoxIcon fontSize="small" />} checked={selected} />} */}
							{getOptionLabel(option)}
						</li>
					);
				}
			}}
		/>
	);
}
